import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useEmbedVideo } from './EmbedVideo.hooks'

const EmbedVideo = props => {
	const [{ classes, className, src, showOverlay, objectFit }] = useEmbedVideo(props)

	return (
		<div className={clsx(classes.root, className, 'embed_video')}>
			<div className={clsx(classes.content, classes[objectFit], 'embed_video-content')}>
				<iframe
					className={clsx(classes.iframe, 'embed_video-iframe')}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
					picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
					allowFullScreen
					loading="lazy"
					src={src}
				/>
				{showOverlay && <div className={clsx(classes.overlay, 'embed_video-overlay')} />}
			</div>
		</div>
	)
}

EmbedVideo.propTypes = {
	className: PropTypes.string,
	shading: PropTypes.number,
	align: PropTypes.string,
	objectFit: PropTypes.oneOf(['contain', 'cover']),
	autoplay: PropTypes.bool,
	metaData: PropTypes.instanceOf(PageMetaData),
}

export default memo(EmbedVideo)
